<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Penjualan</h5>
            </template>

            <b-button class="mr-2 mb-2" name="bulkPenjualan" variant="pgiBtn" @click="openBulkPage()">Bulk Set Jual / Batal</b-button>
            <b-button class="mb-2" name="downloadPenjualan" variant="pgiBtn" @click="confirmPenjualanDownload()">Download Excel Penjualan</b-button>
            
            <hr>

            <div class="big-filter-label filter-form-wrapper mb-3">
                <b-row class="align-items-start justify-content-between">
                    <b-col md="12" lg="9">
                        <b-row>
                            <b-col>
                                <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal Penjualan">
                                    <div class="d-flex search-input-wrapper">
                                        <b-form-input
                                            v-model="input.filterFromDate" name="filterFromDate"
                                            id="filterDate"
                                            type="date"
                                        ></b-form-input>
                                        <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                        <b-form-input
                                            v-model="input.filterToDate" name="filterToDate"
                                            type="date"
                                        ></b-form-input>
                                    </div>
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterNoFaktur" label="No. Faktur">
                                    <b-form-input
                                        v-model="input.filterNoFaktur" name="filterNoFaktur"
                                        type="search"
                                        id="filterNoFaktur"
                                        placeholder="Masukkan no. faktur"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterJenis" label="Jenis">
                                    <b-form-select v-model="input.filterJenis" id="filterJenis" name="jenis" :options="jenisOption" value-field="id" text-field="name">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>Jenis</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                                    <b-form-select v-model="input.filterStatus" id="filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                                        <template v-slot:first>
                                            <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12">
                                <div class="filter-btn-wrapper">
                                    <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                        Search 
                                    </b-button>
                                    <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>

            <div v-if="isShowTable">
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="daftarLelang" 
                    :fields="fields" 
                    :no-local-sorting="false"
                    @sort-changed="sortingChanged" 
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data lelang.
                    </template>
                    <template v-slot:cell(noFaktur)="row">
                        <p class="mb-0">{{row.item.noFaktur}}</p>
                        <p class="mb-0 smallText text-muted">{{$helper.changeDateFormat(row.item.tanggalOrder)}}</p>
                    </template>
                    <template v-slot:cell(sisaPinjaman)="row">
                        <div>
                            <p class="text-right no-wrap mb-0" v-if="row.item.nilaiPinjamanEfektif !== null"> Rp. {{$helper.addThousandSeparator(row.item.nilaiPinjamanEfektif)}} </p>
                            <p class="text-right no-wrap mb-0" v-else>{{$helper.addThousandSeparator(row.item.nilaiPinjamanEfektif)}} </p>
                        </div>
                        <div class="smallText text-muted">
                            <p class="text-right no-wrap mb-0" v-if="row.item.nilaiPinjamanAwal !== null">Awal : Rp. {{$helper.addThousandSeparator(row.item.nilaiPinjamanAwal)}} </p>
                            <p class="text-right no-wrap mb-0" v-else>Awal : {{$helper.addThousandSeparator(row.item.nilaiPinjamanAwal)}} </p>
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="warning" v-if="row.item.status == 'ORDER'">ORDER</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status == 'HILANG'">HILANG</b-badge>
                        <b-badge variant="dark" v-else-if="row.item.status == 'PENGIRIMAN'">PENGIRIMAN</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status == 'DITERIMA'">DITERIMA</b-badge>
                        <b-badge variant="warning" v-else-if="row.item.status == 'KIRIM BALIK'">KIRIM BALIK</b-badge>
                        <b-badge variant="primary" v-else>TERJUAL</b-badge>
                    </template>
                    <template v-slot:head(status)>
                        Status 
                        <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                    </template>
                    <template v-slot:cell(nilaiPinjamanAwal)="row">
                        <div class="text-right no-wrap" v-if="row.item.nilaiPinjamanAwal !== null">Rp. {{$helper.addThousandSeparator(row.item.nilaiPinjamanAwal)}} </div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nilaiPinjamanAwal)}} </div>                 
                    </template>
                    <template v-slot:cell(nilaiPinjamanEfektif)="row">
                        <div class="text-right no-wrap" v-if="row.item.nilaiPinjamanEfektif !== null">Rp. {{$helper.addThousandSeparator(row.item.nilaiPinjamanEfektif)}} </div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nilaiPinjamanEfektif)}} </div>                 
                    </template>
                    <template v-slot:cell(barang)="row">
                        <p class="mb-0">{{row.item.jenis}}</p>
                        <p class="mb-0 smallText text-muted">{{row.item.merk}} - {{row.item.tipe}}</p>
                    </template>
                    <template v-slot:cell(tanggalJual)="row">
                        <div>
                            {{row.item.jualOleh}}
                            <span class="mb-0" v-if="row.item.status == 'TERJUAL'">
                                <i class="fa fa-info tooltip-trigger-btn ml-1" @click="openModalJualDetail(row.item.id)"></i>
                            </span>
                        </div>
                        <div class="smallText text-muted">{{$helper.changeDateFormat(row.item.tanggalJual)}}</div>
                    </template>
                    <template v-slot:cell(hargaJual)="row">
                        <p class="text-right no-wrap mb-0" v-if="row.item.hargaJual !== null">Rp. {{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                        <p class="text-right no-wrap mb-0" v-else>{{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button size="sm" v-if="row.item.status == 'ORDER' || row.item.status == 'DITERIMA' || row.item.status == 'TERJUAL'" variant="pgiBtn" name="btnSetHarga" @click="openModalSetHarga(row.item.noFaktur)">
                            Set Harga Jual
                        </b-button>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
            
            <b-modal id="modal-set-harga" title="Set Harga Jual" @shown="focusFormHargaJual" no-close-on-esc no-close-on-backdrop>
                <b-form id="setHargaForm" @submit.prevent="setHargaJual()">
                    <div class="detail-data-wrapper mb-4">
                        <h6 class="form-title">DATA GADAI</h6>
                        <b-row class="mb-2">
                            <b-col cols="5" class="detail-data-label">No. Faktur</b-col>
                            <b-col v-if="singleDataHarga.noFaktur != null">
                                <strong>
                                    {{singleDataHarga.noFaktur}}
                                </strong>
                            </b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="5" class="detail-data-label">Jenis Barang</b-col>
                            <b-col v-if="singleDataHarga.jenisBarang != null">{{singleDataHarga.jenisBarang}}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="5" class="detail-data-label">Merk Barang</b-col>
                            <b-col v-if="singleDataHarga.merk != null">{{singleDataHarga.merk}}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                        <b-row class="mb-2">
                            <b-col cols="5" class="detail-data-label">Tipe Barang</b-col>
                            <b-col v-if="singleDataHarga.tipe != null">{{singleDataHarga.tipe}}</b-col>
                            <b-col v-else>-</b-col>
                        </b-row>
                    </div>
                    <div class="form-content-wrapper mb-4">
                        <h6 class="form-title">PENJUAL</h6>
                        <b-form-group >
                            <b-input-group>
                                <b-form-input v-model="input.namaPenjual" ref="inputNamaCustomer" v-on:keyup.enter="focusHargaJual" placeholder="Nama Penjual" name="namaPenjual"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                    <div class="form-content-wrapper mb-0">
                        <h6 class="form-title">HARGA</h6>
                        <b-form-group >
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="input.hargaJual" ref="inputHargaJual" v-on:keyup.enter="setHargaJual" name="hargaJual"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </b-form>
                <template v-slot:modal-footer="{ ok, cancel }">
                    <b-button variant="secondary" name="closeSetHargaBtn" :disabled="isSubmitting" @click="cancel()">
                        Cancel
                    </b-button>
                    <b-button variant="pgiBtn" name="setHargaBtn" type="submit" :disabled="isSubmitting" form="setHargaForm">
                        <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                        {{isSubmitting ? 'Memproses...' : 'Set Harga'}}
                    </b-button>
                </template>
            </b-modal>
        </b-card>
        <b-modal id="modal-data-customer" title="Data Customer Lelang" no-close-on-backdrop>
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="detail-data-wrapper mb-0">
                    <h6 class="form-title mb-2">CUSTOMER LELANG</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nama</b-col>
                        <b-col v-if="dataCustomer.nama != null">{{ dataCustomer.nama }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                        <b-col v-if="dataCustomer.telepon != null">{{ dataCustomer.telepon }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Email</b-col>
                        <b-col v-if="dataCustomer.email != null">{{ dataCustomer.email }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Alamat</b-col>
                        <b-col v-if="dataCustomer.alamat != null">{{ dataCustomer.alamat }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeModalBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">ORDER</h6>
                <p class="smallText mb-0">Barang ini masih dalam persiapan untuk dilelangkan. Posisi barang masih di cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">HILANG</h6>
                <p class="smallText mb-0">Barang dinyatakan hilang / tidak ditemukan oleh pihak pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENGIRIMAN</h6>
                <p class="smallText mb-0">Barang dalam pengiriman menuju pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Barang sudah diterima oleh pihak pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">KIRIM BALIK</h6>
                <p class="smallText mb-0">Barang dalam pengiriman kembali dari pelelangan ke cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">TERJUAL</h6>
                <p class="smallText mb-0">Barang sudah terjual.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-periode-penjualan" title="Periode Penjualan" no-close-on-backdrop no-close-on-esc
            :hide-header-close="isSubmitting">
            <form id="downloadPenjualanForm" @submit.prevent="openDownloadPenjualan">
                <div class="search-wrapper align-items-center justify-content-between">
                    <b-form-group
                        label="Periode"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-0"
                    >
                        <div class="d-flex align-items-center search-input-wrapper">
                            <b-form-select class="ml-2 mr-2" v-model="input.bulan" id="inputBulan" name="inputBulan" required :options="optionBulan">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-form-select v-model="input.tahun" id="inputTahun" name="inputTahun" required :options="optionTahun">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>
                    </b-form-group>
                </div>
            </form>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="cancelViewBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="downloadPenjualanBtn" class="download-btn" :disabled="isLoading" form="downloadPenjualanForm" type="submit">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" centered title="Download Excel Penjualan" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'penjualan-lelang',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            isShowTable: false,
            input:{
                show: 10,
                sortBy: null,
                sortDesc: null,
                // fileUploadHarga: null,
                // filterTerjual: 0,
                hargaJual: null,
                namaPenjual: "",
                filterFromDate: null,
                filterToDate: null,
                filterNoFaktur: null,
                filterStatus: -1,
                filterJenis: -1,
                //
                bulan: null,
                tahun: null,
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur" },
                { key: "Barang", label: "Barang" },
                { key: "status", label: "Status" },
                { key: "tanggalJual", label: "Terjual Pada / Oleh"},
                { key: "sisaPinjaman", label: "Sisa Pinjaman"},
                { key: "hargaJual", label: "Harga Jual", sortable:true },
                { key: "action", label: "Action" },
            ],
            filter: null,
            // filterTerjual: [
            //     {id: 0, name: "Belum Terjual"},
            //     {id: 1, name: "Terjual"},
            // ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [
                { id: -1, name: 'Semua' },
                { id: 0, name: 'Order' },
                { id: 1, name: 'Hilang' },
                { id: 2, name: 'Pengiriman' },
                { id: 3, name: 'Diterima' },
                { id: 4, name: 'Kirim Balik' },
                { id: 5, name: 'Terjual' }
            ],
            jenisOption: [
                { id: -1, name: 'Semua' },
                { id: 1, name: 'Elektronik'},
                { id: 2, name: 'BPKB & Kendaraan'},
                { id: 3, name: 'Emas'}
            ],
            daftarLelang: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            cabangId: '',
            loading: false,
            query: "",
            activeSetHarga: null,
            singleDataHarga: {},
            dataCustomer: {},
            //
            
            isLoading: false,
            filePathDownload: "",
            optionTahun: [],
            optionBulan: [
                { value: "1", text: "Januari" },
                { value: "2", text: "Februari" },
                { value: "3", text: "Maret" },
                { value: "4", text: "April" },
                { value: "5", text: "Mei" },
                { value: "6", text: "Juni" },
                { value: "7", text: "Juli" },
                { value: "8", text: "Agustus" },
                { value: "9", text: "September" },
                { value: "10", text: "Oktober" },
                { value: "11", text: "November" },
                { value: "12", text: "Desember" }
            ],
        }
    }, 
    
    watch:{
        "input.hargaJual": function(newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.hargaJual = result);
        },
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 1
			this.toggleBusy()
			var thisYear = new Date().getFullYear()
			for(var i = 2016; i <= thisYear; i++) {
				this.optionTahun.push(i)
			}
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDaftarLelang(){
            this.toggleBusy()
            this.daftarLelang = []
            this.dataHarga = []
            this.isShowTable = true
            
            // if (this.input.filterTerjual != null) this.query = this.query + "&filterTerjual=" + this.input.filterTerjual
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) this.query = this.query + "&filterStartDate=" + this.input.filterFromDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) this.query = this.query + "&filterEndDate=" + this.input.filterToDate
            if (this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if (this.input.filterJenis != -1) this.query = this.query + "&filterJenis=" + this.input.filterJenis
            if (this.input.filterStatus != -1) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if (this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc
     
            this.$axios.get("lelang/"+this.query).then(response => {
              
                this.loading = false
                this.daftarLelang = response.data.data
                this.updateTotalItem(response.data.total)
                
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDaftarLelang()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDaftarLelang()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.input.filterNoFaktur = null
            this.input.filterJenis = -1
            this.input.filterStatus = -1
            this.currentPage = 1
            this.page = 0
            this.input.show = 10
            this.size = this.input.show
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            // this.getDaftarLelang()
            this.isShowTable = false
        },

        onFilter(){
            this.page = 0
            this.size = this.input.show
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true

            if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.getDaftarLelang()
            }
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        openModalSetHarga(id){
            this.activeSetHarga = id
            
            let idx = this.daftarLelang.findIndex(item => item.noFaktur == id);
            this.singleDataHarga = this.daftarLelang[idx]
            if(this.singleDataHarga.hargaJual == null){
                this.input.hargaJual = this.$helper.addThousandSeparator(0)
            }else{
                this.input.hargaJual = this.$helper.addThousandSeparator(this.singleDataHarga.hargaJual)
            }

            this.$bvModal.show("modal-set-harga")
        },
        openModalJualDetail(idLelang){
   
            this.isLoading = true
            this.$bvModal.show("modal-data-customer")
            this.$axios.get(`lelang/customer/`+idLelang).then(response => {
                this.dataCustomer = response.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoading = false
            })
        },
        setHargaJual(){

            if(this.input.hargaJual == ''){
                this.$helper.toastErr(this, 'Mohon isi harga jual terlebih dahulu')
            }else{
                let payload = new FormData()
        
                let nominal = this.$helper.removeThousandSeparator(this.input.hargaJual)

                //----------------- Append Data -----------------

                // payload.append("gadaiId", this.activeSetHarga)
                payload.append("noFaktur", this.activeSetHarga)
                payload.append("hargaJual", nominal)
                payload.append("namaPenjual", this.input.namaPenjual)

                //----------------- Submit Semua Data -----------------

                this.isSubmitting = true
                this.$axios.post("api/lelang/harga_jual", payload).then(response => {
                    let idx = this.daftarLelang.findIndex(item => item.noFaktur == this.activeSetHarga);
                    // this.daftarLelang.splice(idx, 1)
                    this.daftarLelang[idx].status = 'TERJUAL'
                    this.daftarLelang[idx].hargaJual = this.input.hargaJual
                    this.daftarLelang[idx].jualOleh = 'PGI'

                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth()+1; //January is 0!
                    var yyyy = today.getFullYear();
                    if(dd<10){
                            dd='0'+dd
                        } 
                        if(mm<10){
                            mm='0'+mm
                        } 

                    today = yyyy+'-'+mm+'-'+dd;

                    this.daftarLelang[idx].tanggalJual = today
                    this.$helper.toastSucc(this, "Harga Jual telah berhasil disimpan!")
                    this.$bvModal.hide("modal-set-harga")
                })
                .catch(error => {
                    console.log(error)
                    console.log(error.response.data.reason)
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })
            }
        },

        openBulkPage(){
            this.$router.push({path: `${this.$route.path}/bulk-set-jual-batal`});
        },

        confirmPenjualanDownload(){
            this.$bvModal.show('modal-periode-penjualan')
        },

        openDownloadPenjualan(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-periode-penjualan')
            setTimeout(() => { this.axiosPenjualanDownload() }, 500)
        },

        axiosPenjualanDownload(){
            this.$axios.get(`lelang/penjualan/dl/?tahun=${this.input.tahun}&bulan=${this.input.bulan}`).then(response => {
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        focusFormHargaJual(){
            this.$refs.inputNamaCustomer.focus()
        },

        focusHargaJual(){
            this.$refs.inputHargaJual.focus()
        }
    },
    created(){
        this.init()
    }
}
</script>